import Nullstack from 'nullstack';
export default function IconBoxAlignRight({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-box-align-right",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14.248 19.753v-16h5a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-5z"
  }), "   ", Nullstack.element("path", {
    d: "M9.248 19.753h.01"
  }), "   ", Nullstack.element("path", {
    d: "M4.247 19.753h.011"
  }), "   ", Nullstack.element("path", {
    d: "M4.247 14.752h.011"
  }), "   ", Nullstack.element("path", {
    d: "M4.247 8.752h.011"
  }), "   ", Nullstack.element("path", {
    d: "M4.247 3.752h.011"
  }), "   ", Nullstack.element("path", {
    d: "M9.248 3.752h.01"
  }), " ");
}